import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[75vh] md:min-h-screen flex items-end justify-center pb-12 md:pb-20 overflow-hidden" data-id="element-168">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-black" data-id="element-169">
        <img src="https://cdn.magicpatterns.com/uploads/6PuGw4LuyJVnV2FdiMs3Ri/bannerdeluxbarber.png" alt="Barbershop Delux Cut Interior" className="w-full h-full object-cover object-[55%_35%] md:object-center" data-id="element-170" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/20" data-id="element-171"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-173">
          <p className="text-delux-gold font-body tracking-[0.2em] text-sm md:text-base uppercase mb-6" data-id="element-174">
            Barbershop Delux Cut
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-175">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-delux-white leading-tight mb-6" data-id="element-176">
            Descubra Su Lugar Ideal
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-177">
          <p className="font-heading text-xl md:text-2xl text-delux-gold italic mb-10" data-id="element-178">
            Donde el Estilo Cobra Vida
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col items-center space-y-6" data-id="element-179">
          <a href="#contacto" className="bg-delux-gold hover:bg-delux-gold-light text-delux-bg px-8 py-4 rounded font-heading font-bold text-lg tracking-wide transition-all duration-300 hover:shadow-[0_0_20px_rgba(200,164,90,0.5)] transform hover:-translate-y-1" data-id="element-180">
            Reserva Tu Experiencia
          </a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-delux-body font-body text-sm md:text-base opacity-90" data-id="element-181">
            <div className="flex items-center gap-2" data-id="element-182">
              <MapPinIcon className="w-5 h-5 text-delux-gold" data-id="element-183" />
              <span data-id="element-184">
                Sunshine Plaza | 1145 Homestead Rd N, Lehigh Acres, FL 33936
              </span>
            </div>
            <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-delux-gold" data-id="element-185"></div>
            <div className="flex items-center gap-2" data-id="element-186">
              <PhoneIcon className="w-5 h-5 text-delux-gold" data-id="element-187" />
              <a href="tel:7866516944" className="hover:text-delux-gold transition-colors" data-id="element-188">
                (786) 651-6944
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}